import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "stage" }
const _hoisted_2 = { class: "stage-inner" }
const _hoisted_3 = { class: "lead" }
const _hoisted_4 = {
  key: 0,
  class: "card"
}
const _hoisted_5 = { class: "card" }
const _hoisted_6 = { class: "card" }
const _hoisted_7 = { class: "card action" }
const _hoisted_8 = {
  key: 0,
  class: "danger"
}
const _hoisted_9 = { class: "buttons" }
const _hoisted_10 = ["disabled"]
const _hoisted_11 = ["disabled"]
const _hoisted_12 = { class: "buttons" }
const _hoisted_13 = { class: "card" }
const _hoisted_14 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[4] || (_cache[4] = _createStaticVNode("<div class=\"blobs\" aria-hidden=\"true\" data-v-091ccb07><span class=\"blob b1\" data-v-091ccb07></span><span class=\"blob b2\" data-v-091ccb07></span><span class=\"blob b3\" data-v-091ccb07></span><span class=\"blob b4\" data-v-091ccb07></span></div>", 1)),
    _createElementVNode("div", _hoisted_2, [
      _cache[3] || (_cache[3] = _createElementVNode("p", { class: "kicker" }, "Rainbow Manager", -1)),
      _createElementVNode("h1", null, _toDisplayString(_ctx.t('accountDeleteTitle')), 1),
      _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.t('accountDeleteIntro')), 1),
      (_ctx.deleted)
        ? (_openBlock(), _createElementBlock("article", _hoisted_4, [
            _createElementVNode("h2", null, _toDisplayString(_ctx.t('accountDeleteDoneTitle')), 1),
            _createElementVNode("p", null, _toDisplayString(_ctx.t('accountDeleteDoneText')), 1)
          ]))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("article", _hoisted_5, [
              _createElementVNode("h2", null, _toDisplayString(_ctx.t('accountDeleteWhatTitle')), 1),
              _createElementVNode("ul", null, [
                _createElementVNode("li", null, _toDisplayString(_ctx.t('accountDeleteWhatProfile')), 1),
                _createElementVNode("li", null, _toDisplayString(_ctx.t('accountDeleteWhatGallery')), 1),
                _createElementVNode("li", null, _toDisplayString(_ctx.t('accountDeleteWhatChats')), 1),
                _createElementVNode("li", null, _toDisplayString(_ctx.t('accountDeleteWhatUsage')), 1)
              ])
            ]),
            _createElementVNode("article", _hoisted_6, [
              _createElementVNode("h2", null, _toDisplayString(_ctx.t('accountDeleteKeepTitle')), 1),
              _createElementVNode("p", null, _toDisplayString(_ctx.t('accountDeleteKeepStore')), 1)
            ]),
            _createElementVNode("article", _hoisted_7, [
              (_ctx.email)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("p", null, _toDisplayString(_ctx.t('accountDeleteSignedInAs', { email: _ctx.email })), 1),
                    (_ctx.confirming)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(_ctx.t('accountDeleteConfirmQuestion')), 1))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_9, [
                      (_ctx.confirming)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            class: "button ghost",
                            type: "button",
                            disabled: _ctx.deleting,
                            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.confirming = false))
                          }, _toDisplayString(_ctx.t('accountDeleteCancel')), 9, _hoisted_10))
                        : _createCommentVNode("", true),
                      _createElementVNode("button", {
                        class: "button remove",
                        type: "button",
                        disabled: _ctx.deleting,
                        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onDelete && _ctx.onDelete(...args)))
                      }, _toDisplayString(_ctx.confirming ? _ctx.t('accountDeleteConfirmAction') : _ctx.t('accountDeleteAction')), 9, _hoisted_11)
                    ])
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createElementVNode("p", null, _toDisplayString(_ctx.t('accountDeleteSignInFirst')), 1),
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("button", {
                        class: "button",
                        type: "button",
                        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.goToSignIn && _ctx.goToSignIn(...args)))
                      }, _toDisplayString(_ctx.t('accountDeleteSignIn')), 1)
                    ])
                  ], 64))
            ]),
            _createElementVNode("article", _hoisted_13, [
              _createElementVNode("h2", null, _toDisplayString(_ctx.t('accountDeleteNoAccessTitle')), 1),
              _createElementVNode("p", null, _toDisplayString(_ctx.t('accountDeleteNoAccessText', { email: _ctx.SUPPORT_EMAIL })), 1),
              _createElementVNode("a", {
                class: "link",
                href: `mailto:${_ctx.SUPPORT_EMAIL}`
              }, _toDisplayString(_ctx.SUPPORT_EMAIL), 9, _hoisted_14)
            ])
          ], 64))
    ])
  ]))
}